import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEraserSimple: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="eraser-simple, rubber, clean-up"><path d="M6.5 10.5L13.5 17.5" stroke="currentColor" strokeWidth="1.5"/><path d="M14.25 2.75L2.75 14.25L9.75 21.25L21.25 9.75L14.25 2.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconEraserSimple;
